import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppInitService } from 'src/app/digigov/services/app-init.service';

@Injectable({
  providedIn: 'root',
})
export class WorktrayService {
  worktrayConfig: any = { WorktrayNamePattern: null, WorktrayNameLength: null };
  processConfig: any = {
    SHOW_SEARCH_FILTER: 0,
  };
  constructor(
    private http: HttpClient,
    private appInitService: AppInitService
  ) {
    this.appInitService?.getConfigurableFields()?.subscribe(() => {
      Object?.keys(this.appInitService?.appConfig?.configurableFields)?.forEach(
        (ele) => {
          try {
            if (ele == 'WorktrayNamePattern') {
              this.worktrayConfig.WorktrayNamePattern = this.appInitService?.appConfig?.configurableFields[
                ele
              ];
            } else if (ele == 'WorktrayNameLength') {
              this.worktrayConfig.WorktrayNameLength = this.appInitService?.appConfig?.configurableFields[
                ele
              ];
            } else if (ele === 'SHOW_SEARCH_FILTER') {
              this.processConfig.SHOW_SEARCH_FILTER = Number(
                this.appInitService?.appConfig?.configurableFields[ele]
              );
            }
          } catch (e) {}
        }
      );
    });
  }
  getAllApplication() {
    return this.http.get(`/admin/application?appName=`).pipe(
      map((response: any) => response),
      catchError((error) => throwError(error))
    );
  }
  getAllWorktrays(postJson: any): Observable<any> {
    return this.http.post('/admin/get-grp-worklist', postJson);
  }

  getAssociatedUsersGrid(postJson): Observable<any> {
    return this.http.post('/admin/get-unit-grp-mpg', postJson);
  }

  createWorktray(postJson): Observable<any> {
    return this.http.post('/admin/create-grp-worklist', postJson);
  }

  updateWorktrya(postJson): Observable<any> {
    return this.http.post('/admin/update-grp-worklist', postJson);
  }

  getListOfRoleAccociatedWithUser(empId): Observable<any> {
    return this.http.get(`/admin/get-role-by-empid?employeeId=${empId}`);
  }

  getAllEmployees(): Observable<any> {
    let postData = {
      ComboId: '20003',
      ACTIVE_FLAG: 1,
    };
    return this.http.post(`/worklist/get-combo-list`, postData);
  }

  getAllMappedEmployees(grpId: any): Observable<any> {
    let postData = {
      wlGrpId: Number(grpId),
    };
    const url = `/admin/get-unit-grp-mpg`;
    return this.http.post(url, postData);
  }

  getEmployeeSearchDetails(empId?: number | string): Observable<any> {
    const url = `/admin/employee-details/${empId}`;
    return this.http.get(url).pipe(
      map((response: any) => response),
      catchError((error) => {
        throw error;
      })
    );
  }

  editWorktrayUniqueName(name: string, grpId): Observable<any> {
    const checkName = {
      wlGrpName: name,
      wlGrpId: grpId,
    };
    return this.http.post(`/admin/unique-worktray-name`, checkName);
  }
  getWorktrayAuditByWorktrayId(postData) {
    return this.http.post(`/admin/grpwrklist-audit-details`, postData);
  }
}
